import {useStompClient, useSubscription} from "react-stomp-hooks";
import React, {useState} from "react";
import {StompHeaders} from "@stomp/stompjs";
import {useKeycloak} from "@react-keycloak/web";
import {Button, message, Tooltip} from "antd";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import videoService from "../../../service/videoService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRecordVinyl} from "@fortawesome/free-solid-svg-icons";

export default function RecordVideoButton({username, participantConnectingStatus, canShowRecording}: {
    username: string,
    participantConnectingStatus: ParticipantStatus,
    canShowRecording(value: boolean): any
}) {

    return (<SubscribingComponent username={username} setCanShowRecording={canShowRecording}
                           participantConnectingStatus={participantConnectingStatus}/>)

}

const SubscribingComponent: React.FC<{
    username: string,
    participantConnectingStatus: string,
    setCanShowRecording(value: boolean): any
}> = ({username, participantConnectingStatus, setCanShowRecording}) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [recording, setRecording] = useState<boolean>(false);
    const {keycloak} = useKeycloak();
    let stompHeaders: StompHeaders = {
        "accessToken": keycloak.token ? keycloak.token : "",
        "username": username
    }

    const stompClient = useStompClient();
    const onRecording = (e: any) => {
        if (recording) {
            setRecording(false);
            videoService.stopRecording(username).then(res => {
                if (res.data.status !== "SUCCESS") {
                    setRecording(false);
                }
                console.log("Recording Data", res.data);
            }, reason => setRecording(false));

        } else {
            if (participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED) {
                setRecording(true);
                videoService.startRecording(username).then(res => {
                    if (res.data.status !== "SUCCESS") {
                        setRecording(prevState => !prevState);
                    }
                    console.log("Recording Data", res.data);
                }, reason => setRecording(prevState => !prevState));
                console.log(stompClient)
                /*stompClient?.publish({
                    destination: `/video/app/check-image-upload-status`,
                    body: JSON.stringify({
                        "imageType": imageType,
                        "uploadStatus": UploadStatus.UPLOADING,
                        "username": username
                    })
                });*/


            } else {
                messageApi.open({
                    key: "Video",
                    type: 'warning',
                    content: `Participant not connected`,
                    duration: 3,
                });
            }
        }
    }


    useSubscription("/user/topic/check-image-upload-status", (message) => {
        let res: any = JSON.parse(message.body);
        stompClient?.publish({
            destination: `/video/app/acknowledge`,
            body: message.headers.messageId
        });
        console.log(`check-image-upload-status Acknowledgment sent for message: ${message.headers.messageId}`);
        if (res.content, res.errorMessage) {
            messageApi.open({
                key: "Video",
                type: 'error',
                content: `Video Can not be Recorded`,
                duration: 3,
            });
        } else {
            /*if (imageType == res.imageType) {
                if (res.uploadStatus == UploadStatus.UPLOADED) {
                    messageApi.open({
                        key: imageType,
                        type: 'success',
                        content: `${imageType} Successfully Uploaded`,
                        duration: 3,
                    });
                } else {
                    messageApi.open({
                        key: imageType,
                        type: 'error',
                        content: `${imageType} Can not be Uploaded`,
                        duration: 3,
                    });
                }

            }*/
        }
    }, stompHeaders);

    useSubscription("/user/topic/local-recording_start", (message) => {
        if (message.body) {
            console.log("=========== Video Recording Started ================")
            setCanShowRecording(true)
        } else {
            console.log("=========== Failed to Start Video Recoding ================")
            setCanShowRecording(false)
        }
    }, stompHeaders);

    useSubscription("/user/topic/local-recording_stop", (message) => {
        if (message.body) {
            console.log("=========== Video Recording Stopped ================")
            setCanShowRecording(false)
        } else {
            console.log("=========== Failed to Stop Video Recoding ================")
            setCanShowRecording(false)
        }
    }, stompHeaders);

    return <>
        {contextHolder}
        <Tooltip title={recording ? "Click to stop recording" : "Click to record video"}>
            <Button type="primary" style={{backgroundColor: recording ? '#de0000' : '#008d86'}} shape="circle"
                    icon={<FontAwesomeIcon icon={faRecordVinyl}/>} onClick={onRecording} size={"large"}/>
        </Tooltip>

    </>
}
